const e = "0123456789AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz", a = (l = 21) => {
  let t = "", n = l;
  for (; n--; )
    t += e[Math.random() * e.length | 0];
  return t;
};
export {
  a as default
};
